<template>
    <div>
        <card-header title="Edit Enrollment Option" icon="fa-pencil"/>

        <card-body>
            <course-config-form :config="config"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteConfig"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Option?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!config.title"
                    ><i class="fas fa-check mr-2"></i>Save Enrollment Option
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from '@/http_client';
    import CourseConfigForm from "./ConfigForm";
    import moment from "moment/moment";

    export default {
        components: {CourseConfigForm, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                config: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadConfig: function() {
                this.$emit('loading', true);
                http.get('courses/' + this.props.courseId + '/configs/' + this.props.configId, {force: true}).then(response => {
                    this.config = response.data;
                    this.config.enabled_at = (response.data.enabled_at) ? moment(response.data.enabled_at).toDate() : null;
                    this.config.disabled_at = (response.data.disabled_at) ? moment(response.data.disabled_at).toDate() : null;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.log(err);
                    this.$emit('loading', false);
                });
            },
            submit: function() {
                http.put('courses/' + this.props.courseId + '/configs/' + this.props.configId, {
                    id: this.config.id,
                    title: this.config.title,
                    price: this.config.price,
                    enrollment_term_months: this.config.enrollment_term_months || null,
                    units: this.config.units,
                    is_enabled: this.config.is_enabled,
                    is_hidden: this.config.is_hidden,
                    enabled_at: this.config.enabled_at,
                    disabled_at: this.config.disabled_at
                }, {force: true}).then(response => {
                    this.$reloadCard('course-configs', {courseId: this.props.courseId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the enrollment option.');
                    this.$emit('loading', false);
                });
            },
            deleteConfig() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('courses/' + this.props.courseId + '/configs/' + this.config.id).then(response => {
                        this.$reloadCard('course-configs', {courseId: this.props.courseId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {
                        console.log(err);
                        this.$emit('loading', false);
                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.configId': function() {
                this.dirty = null;
                this.loadConfig();
            },
            'config': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this enrollment option? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadConfig();
        }
    };
</script>
